<template lang="pug">
  v-card(flat)
    .box-image(@click.stop="loadAndOpen")
      img(:src="box.image" width="100%")
      span.box-quantity x{{box.input.overview.quantity}}
    v-dialog(v-model="dialog.detail.delay" v-if="dialog.detail.open" fullscreen persistent transition="dialog-bottom-transition")
      v-toolbar.primary(dense)
        v-spacer
        v-btn(icon small @click.stop="dialog.detail.open = false")
          v-icon.white--text close
      v-card(tile)
        order-arrange(:token="token" :box-index="boxIndex")
</template>

<script>
import OrderArrange from './Arrange'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['token', 'boxIndex'],
  components: {
    OrderArrange
  },
  data () {
    return {
      box: null,
      dialog: {
        detail: {
          open: false,
          delay: false
        }
      }
    }
  },
  created () {
    this.box = this.getBox(this.token, this.boxIndex)
  },
  watch: {
    'dialog.detail.open': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.detail.delay = v
      }, 30)
    },
    'dialog.detail.delay': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.detail.open = v
      }, 30)
    }
  },
  computed: {
    ...mapGetters('app/list', ['getOrder', 'getBox'])
  },
  methods: {
    ...mapActions('app/list', ['updateOrder']),
    loadAndOpen () {
      let self = this
      let order = self.getOrder(self.token)
      if (!order.downsized) {
        self.dialog.detail.open = true
        return
      }
      self.$ajax.get(`order/load/${order.token}`).then(function (response) {
        self.updateOrder({
          token: self.token,
          order: response.data.order
        })
        self.dialog.detail.open = true
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.box-image {
  position: relative;
  margin: 3px;

  &:hover {
    cursor: pointer;
    margin: 0px;
    border: 3px solid rebeccapurple;
  }

  .box-quantity {
    position: absolute;
    right: 3px;
    bottom: 0;
    color: rebeccapurple;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/pages/List/Components/SettledBox.vue